import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import { SearchkitComponent } from "./SearchkitComponent";
export var LoadingComponent =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(LoadingComponent, _SearchkitComponent);

  function LoadingComponent() {
    _classCallCheck(this, LoadingComponent);

    return _possibleConstructorReturn(this, _getPrototypeOf(LoadingComponent).apply(this, arguments));
  }

  _createClass(LoadingComponent, [{
    key: "render",
    value: function render() {
      if (this.isLoading()) {
        return this.props.children;
      }

      return React.createElement("div", null);
    }
  }]);

  return LoadingComponent;
}(SearchkitComponent);